import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";

const S11 = (props) => {
    const radio = useRadioInput({
        name: "sale[discovery][inspection]", label: "Har det vært undersøkelser av en proffesjonell aktør etter du oppdaget mangelen?",
        options: {
            data: [
                { label: "Ja, tilstandsrapport", value: "YES_NAF" },
                { label: "Ja, hos verksted", value: "YES_WORKSHOP" },
                { label: "Ja, hos selger", value: "YES_SELLER" },
                { label: "Nei", value: "NO" },
                // { label: "Annet/ikke relevant", value: "OTHER" },
            ],
        },
        ...props,
    })

    return (
        <Wrapper {...props} header="Har du oppsøkt professionel vurdering?">
            <RadioInput {...radio.props}/>
        </Wrapper>
    );
};

export default S11;
